import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { company } from "../config";

// Minimal document-head manager. No helmet dependency: this site has one title,
// one description and one canonical per route, and that is all it needs.
//
// public/index.html carries the pre-hydration defaults for crawlers that do not
// execute JS. This keeps the tags correct once React is running.

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    const [, name] = selector.match(/\[(?:name|property)="([^"]+)"\]/) || [];
    el.setAttribute(selector.includes("property=") ? "property" : "name", name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const full = title && title !== company.brand ? `${title} | ${company.brand}` : company.brand;
    document.title = full;

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", full);
    setMeta('meta[property="og:description"]', "content", description);

    const url = company.siteUrl ? `${company.siteUrl}${pathname}` : "";
    setMeta('meta[property="og:url"]', "content", url);
    setCanonical(url);
  }, [title, description, pathname]);

  return null;
}
